module.exports = __webpack_public_path__ + "static/media/s_archery.0b92cb7d.mp3";